import styled from 'styled-components';
import { Anchor, spaceMixin, token } from '@zillow/constellation';

export const ZillowNavbarLogoAnchor = styled(Anchor)`
    margin: auto;
    &:focus {
        box-shadow: none;
        outline-offset: ${spaceMixin('xs')};
        outline: 2px solid ${token('colors.blue400')};
    }
`;
